import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs';

export const coreWorkflowInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiBaseUrl)) {
    const newUrl = req.url
      // .replace(environment.apiBaseUrl + '/rest/workflows', environment.coreWorkflowURL + '/v1/workflow')
      // .replace('workflow/task/process', 'workflow/task-process');
    return next(
      req.clone({
        url: newUrl,
      }),
    );
  }

  return next(req);
};
